import type { FC } from 'react';
import React, { useContext } from 'react';

import { THREE_HUNDRED_SIXTY_FIVE_DAYS_IN_SECONDS } from '@confluence/automation-discovery/entry-points/constants.ts';
import { LazyAutomationDiscoveryHoverPageTitleMessage } from '@confluence/automation-discovery/entry-points/AutomationDiscoveryHoverPageTitleMessage.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary.ts';
import { useSpaceKey } from '@confluence/space-utils/entry-points/useSpaceKey.ts';

import { PageCardContext } from '../PageCardContext.ts';

const getIsPageUpdatedOlderThan365Days = (lastModifiedDate: any): boolean => {
	const getPageUpdatedInSeconds = (lastModifiedRaw): number => {
		const lastModifiedDate = new Date(lastModifiedRaw);
		return (Date.now() - lastModifiedDate.getTime()) / 1000;
	};

	return getPageUpdatedInSeconds(lastModifiedDate) > THREE_HUNDRED_SIXTY_FIVE_DAYS_IN_SECONDS;
};

type AutomationDiscoveryMessageProps = {
	shouldUseAutomationDiscovery?: boolean;
};
const AutomationDiscoveryMessageInner: FC<AutomationDiscoveryMessageProps> = ({
	shouldUseAutomationDiscovery,
}) => {
	const {
		status,
		lastAction: { when },
		type,
	} = useContext(PageCardContext);
	const spaceKey = useSpaceKey();

	const shouldRender =
		shouldUseAutomationDiscovery &&
		type === 'page' &&
		status !== 'draft' &&
		getIsPageUpdatedOlderThan365Days(when);

	return (
		<>{shouldRender && <LazyAutomationDiscoveryHoverPageTitleMessage spaceKey={spaceKey} />}</>
	);
};

export const AutomationDiscoveryMessage: FC<AutomationDiscoveryMessageProps> =
	withTransparentErrorBoundary({
		attribution: Attribution.AUTOMATION_FOR_CONFLUENCE,
	})(AutomationDiscoveryMessageInner);
